import { FormattedMessage } from 'react-intl';

import { PickerOnboardingDialog } from '#src/components/missions/picker/PickerOnboardingDialog/index.tsx';

import leftCard from './assets/left-card.webp';
import rightCard from './assets/right-card.webp';
import twoCards from './assets/two-cards.webp';

type Props = {
  onClose: () => void;
  cardsCount: number;
};
export const DropChallengePickerOnboardingDialog = ({
  onClose,
  cardsCount,
}: Props) => {
  return (
    <PickerOnboardingDialog
      onClose={onClose}
      leftImg={leftCard}
      rightImg={rightCard}
      mobileImg={twoCards}
      greenText={<FormattedMessage defaultMessage="WIN A 4★ OR 5★ CARD" />}
      mainText={<FormattedMessage defaultMessage="Scrap Challenge" />}
      secondaryText={
        <FormattedMessage
          defaultMessage="Scrap {cardsCount, number} for greatness"
          values={{ cardsCount }}
        />
      }
      captionText={<FormattedMessage defaultMessage="Rules change daily" />}
    />
  );
};
